module.exports = __webpack_public_path__ + "img/icon (5).ac0c84b2.png";